import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-83d54a20"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "user-info" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "考卷信息", -1))
const _hoisted_3 = { class: "table" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "准考证号", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "学员姓名", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "证件号码", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("label", null, "考试科目"),
  /*#__PURE__*/_createTextVNode("企业二级标准化创建能力")
], -1))

import { ref } from 'vue'
    import store from "@/store"
    
export default /*#__PURE__*/_defineComponent({
  __name: 'user-info',
  props: ['data', 'index'],
  setup(__props) {

    
    const exam = ref(store.state.exam)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("ul", null, [
        _createElementVNode("li", null, [
          _hoisted_4,
          _createTextVNode(_toDisplayString(exam.value.admissionTicket), 1)
        ]),
        _createElementVNode("li", null, [
          _hoisted_5,
          _createTextVNode(_toDisplayString(exam.value.studenName), 1)
        ]),
        _createElementVNode("li", null, [
          _hoisted_6,
          _createTextVNode(_toDisplayString(exam.value.idcardNo), 1)
        ]),
        _hoisted_7
      ])
    ])
  ]))
}
}

})